import { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { get } from 'lodash'

import { actions as visitTypeActions } from 'store/calendar-visit-type-filter'
import { actions } from 'store/selected-schools'

const boolToVirtual = (val) => {
  if (val === true) {
    return 'only'
  } else if (val === false) {
    return 'ignore'
  }
  return ''
}

const useCalendarTransition = (hsId, hsName) => {
  const dispatch = useDispatch()
  const virtual = useSelector((store) => get(store.mapFilters, 'record.virtual'))
  return useCallback(() => {
    dispatch(actions.setSelectedSchools([{ Id: hsId, Name: hsName }]))
    dispatch(visitTypeActions.changeFilter({ name: 'virtual', value: boolToVirtual(virtual) }))
  }, [dispatch, virtual, hsId, hsName])
}

export default useCalendarTransition
